export default "__VITE_ASSET__CHRChbnP__"